import { render } from "./navbar.vue?vue&type=template&id=e21438da&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=e21438da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e21438da"

export default script